import { axios, AxiosResponse } from '~/modules'
import { IEchocardiogramTest, IFetchEchocardiogramTest } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchEchocardiogramTest = async (params: IFetchEchocardiogramTest): Promise<IEchocardiogramTest> => {
  const { pathParams } = params

  const response = await axios.get(`${hstoryAPI}/echocardiogram-tests/${pathParams.testId}`)
  const { data }: AxiosResponse<IEchocardiogramTest> = response
  return data
}
